import script from "./MapIconWrap.vue?vue&type=script&setup=true&lang=js"
export * from "./MapIconWrap.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__